import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable  @typescript-eslint/no-explicit-any */
import { EEstimationTargets } from '../../types';
import { getFlatGeoSuggest } from './getFlatGeoSuggest';
import { getJKGeoSuggest } from './getJKGeoSuggest';
/**
 * Санк-экшн для запроса геосаджеста при вводе в фильтр адреса
 * В зависимости от типа оцениваемой недвижимости, определяет, какой саджест загружать
 * */

export var getAddressGeoSuggest = function getAddressGeoSuggest(addressChunk, targetPage) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, estimationTarget;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), estimationTarget = _getState.filters.estimationTarget;
              _context.t0 = estimationTarget;
              _context.next = _context.t0 === EEstimationTargets.flat ? 4 : _context.t0 === EEstimationTargets.house ? 4 : _context.t0 === EEstimationTargets.land ? 4 : _context.t0 === EEstimationTargets.newbuilding ? 5 : 6;
              break;

            case 4:
              return _context.abrupt("return", dispatch(getFlatGeoSuggest(addressChunk, targetPage)));

            case 5:
              return _context.abrupt("return", dispatch(getJKGeoSuggest(addressChunk)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};